<template>
  <div class="footer">
    <div class="max-width row-block">
      <div class="data-container" :class="[isMobile ? 'col-block' : 'row-block']">
        <a
          :href="content.link"
          target="_blank"
          class="data-block row-block"
          :class="{
            'flex-reverse': content.reverse
          }"
          v-for="(content, index) in contents"
          :key="index"
        >
          <img v-if="content.icon" class="data-icon" :src="content.icon" alt="">
          <div :style="{ width: content.gap || '10px' }"></div>
          <div v-if="content.title" class="data-title">{{ content.title }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import responsitive from '../../mixins/responsitive.vue'

export default {
  mixins: [
    responsitive
  ],
  computed: {
    // static
    contents () {
      return [
        {
          title: '康百事生物資訊股份有限公司'/* ___ */,
          icon: require('../../assets/images/linkedin-brands.svg'),
          link: 'https://www.linkedin.com/company/compass-bioinformatics',
          gap: '15px',
          reverse: true
        },
        {
          title: '+886-3-5745-009'/* ___ */,
          icon: require('../../assets/images/phone-solid.svg'),
          link: 'tel:+886-3-5745-009'
        },
        {
          title: '新竹市東區慈雲路 118 號 17 樓之 10'/* ___ */,
          icon: require('../../assets/images/map-marker-alt-solid.svg'),
          link: 'https://www.google.com/maps/place/300新竹市东区慈云路118號'
        },
        {
          title: 'service@compassbioinfo.com'/* ___ */,
          icon: require('../../assets/images/envelope-solid.svg'),
          link: 'mailto:service@compassbioinfo.com'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue